export const getDefaultValues = (details) => ({
  TransactionAmountTypeLable: details?.TransactionAmountTypeLable || '',
  TransactionAmountTypeLogo: details?.TransactionAmountTypeLogo || '',
  TransactionAmountTypeHelp: details?.TransactionAmountTypeHelp || '',
});
